'use client';
import ProductsPage from '@c/ProductsPage';
import { BrandDocument } from '@models/brand';
import { CategoryDocument } from '@models/category';
import { PageSideFilters, TopFilters } from '@util/hooks/useProductsPage';
import { Pagination } from '@util/types/paginator';
import { ProductDocument } from 'models/product';
import { PublicUserDocument } from 'models/user';

export interface BrandDetailPageProps {
  brand: BrandDocument;
  initialProducts: ProductDocument[];
  initialPageInfo: Pagination;
  initialTopFilters: TopFilters;
  initialSideFilters: PageSideFilters;
  categories: CategoryDocument[];
  sellers: {
    [key: string]: PublicUserDocument;
  };
}

const BrandDetailPage = ({
  brand,
  initialProducts,
  initialPageInfo,
  initialTopFilters,
  initialSideFilters,
  sellers,
}: BrandDetailPageProps) => {
  return (
    <ProductsPage
      initialProducts={initialProducts}
      initialPageInfo={initialPageInfo}
      initialTopFilters={initialTopFilters}
      initialSideFilters={initialSideFilters}
      headerBreadcrumb={{ label: brand.name, href: brand.url }}
      pageHeaderTitle={brand.name}
      pageHeaderBody={brand.description}
      brand={brand}
      pageType="brand"
      keyword={null}
      seller_id={null}
      categories={[]}
      sellers={sellers}
    />
  );
};

export default BrandDetailPage;
